import { type IDataObject, type OrderBy } from '@inpart-io/devtools-iap';
import { GET_BY_ID_LIST } from '@inpart-io/devtools-vue';
import { type BoardLayout } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { DEFAULT_PAGE_SIZE, DEFAULT_PAGINATION, DEFAULT_SEARCH_KEY } from './constants';
import { type IPagination, type ISearchState } from './types';

export const GET_SEARCH_RESULT_LIST = 'getSearchResultList';
export const GET_SEARCH_RESULT_ID_LIST = 'getSearchResultIdList';
export const GET_SEARCH_RESULT_ID_LIST_BY_KEY = 'getSearchResultIdListByKey';
export const GET_PAGINATION = 'getPagination';
export const GET_PAGINATION_TIMESTAMP = 'getPaginationTimestamp';
export const GET_SEARCH_TIMESTAMP = 'getSearchTimestamp';
export const GET_CURRENT_PAGE = 'getCurrentPage';
export const GET_PAGE_SIZE = 'getPageSize';
export const GET_VISIBLE_COLUMNS = 'getVisibleColumns';
export const GET_LAYOUT = 'getLayout';
export const GET_PAGE_COUNT = 'getPageCount';
export const GET_ROWS_COUNT = 'getRowsCount';
export const GET_START_INDEX = 'getStartIndex';
export const GET_ORDER_BY = 'getOrderBy';
export const GET_ROWS_PER_PAGE_OPTIONS = 'getRowsPerPageOptions';

export function getGetters(): GetterTree<ISearchState, unknown> {
    return {
        [GET_SEARCH_RESULT_LIST]: (_state, _getters) => {
            return (key = DEFAULT_SEARCH_KEY): IDataObject[] => {
                if (_state.search.has(key)) {
                    return _getters[GET_BY_ID_LIST](_state.search.get(key));
                }
                return [];
            };
        },
        [GET_SEARCH_RESULT_ID_LIST_BY_KEY]: (_state) => {
            return (key = DEFAULT_SEARCH_KEY): number[] | null => {
                if (_state.search.has(key)) {
                    return _state.search.get(key);
                }
                return null;
            };
        },
        [GET_SEARCH_RESULT_ID_LIST]: (_state) => {
            return (key = DEFAULT_SEARCH_KEY): number[] => {
                if (_state.search.has(key)) {
                    return _state.search.get(key);
                }
                return [];
            };
        },
        [GET_PAGINATION]: (_state) => {
            return (key = DEFAULT_SEARCH_KEY): IPagination => {
                if (_state.pagination.has(key)) {
                    return _state.pagination.get(key);
                } else {
                    return Object.assign({}, DEFAULT_PAGINATION);
                }
            };
        },
        [GET_CURRENT_PAGE]: (_state, _getters) => {
            return (key = DEFAULT_SEARCH_KEY): number => {
                return _getters[GET_PAGINATION](key).currentPage;
            };
        },
        [GET_PAGE_SIZE]: (_state, _getters) => {
            return (key = DEFAULT_SEARCH_KEY): number => {
                return _getters[GET_PAGINATION](key).pageSize;
            };
        },
        [GET_VISIBLE_COLUMNS]: (_state, _getters) => {
            return (key = DEFAULT_SEARCH_KEY): string[] => {
                return _getters[GET_PAGINATION](key).visibleColumns;
            };
        },
        [GET_LAYOUT]: (_state, _getters) => {
            return (key = DEFAULT_SEARCH_KEY): BoardLayout => {
                return _getters[GET_PAGINATION](key).layout;
            };
        },
        [GET_PAGE_COUNT]: (_state, _getters) => {
            return (key = DEFAULT_SEARCH_KEY): number => {
                const pagination: IPagination = _getters[GET_PAGINATION](key);
                return Math.ceil(pagination.rowsNumber / pagination.pageSize);
            };
        },
        [GET_START_INDEX]: (_state, _getters) => {
            return (key = DEFAULT_SEARCH_KEY): number => {
                const pagination: IPagination = _getters[GET_PAGINATION](key);
                return pagination.pageSize * (pagination.currentPage - 1);
            };
        },
        [GET_ROWS_COUNT]: (_state, _getters) => {
            return (key = DEFAULT_SEARCH_KEY): number => {
                return _getters[GET_PAGINATION](key).rowsNumber;
            };
        },
        [GET_SEARCH_TIMESTAMP]: (_state) => {
            return (): string => {
                return _state.timestamp;
            };
        },
        [GET_PAGINATION_TIMESTAMP]: (_state, _getters) => {
            return (key = DEFAULT_SEARCH_KEY): string => {
                const pagination: IPagination = _getters[GET_PAGINATION](key);
                return pagination.timestamp;
            };
        },
        [GET_ORDER_BY]: (_state, _getters) => {
            return (key = DEFAULT_SEARCH_KEY): OrderBy[] => {
                return _getters[GET_PAGINATION](key).orderBy ?? [];
            };
        },
        [GET_ROWS_PER_PAGE_OPTIONS]: (_state) => {
            return (): number[] => {
                return [DEFAULT_PAGE_SIZE / 2, DEFAULT_PAGE_SIZE, (DEFAULT_PAGE_SIZE * 5) / 2, DEFAULT_PAGE_SIZE * 5];
            };
        }
    };
}
